module.exports = __webpack_public_path__ + "3059d606e43fea58d959a586c2b09a47.ttf";